import { ConstantProductRPool, HEXer,LiquidityProviders, MultiRoute, PoolCode, RouteLeg } from '@emberswap/emberswap-sdk2/dist/entities'


/**
 *
 */
export class ConstantProductPoolCode extends PoolCode {
  /**
   * @param {ConstantProductRPool}pool
   * @param {LiquidityProviders}liquidityProvider
   * @param {string}providerName
   * @param {string} exchangeUri
   */
  constructor(
    pool: ConstantProductRPool,
    liquidityProvider: LiquidityProviders,
    providerName: string,
    exchangeUri: string
  ) {
    super(pool, liquidityProvider, `${providerName} ${(pool?.fee || 0) * 100}%`, exchangeUri)
  }


  /**
   * @param {RouteLeg}leg
   * @param {MultiRoute}_route
   * @param {string}to
   * @return {string}
   */
  getSwapCodeForRouteProcessor2(leg: RouteLeg, _route: MultiRoute, to: string): string {
    const code = new HEXer()
      .uint8(0) // uniV2 pool
      .address(this.pool.address)
      .bool(leg.tokenFrom.address == this.pool.token0.address)
      .address(to)
      // .bool(presended)
      .toString()
    return code
  }

}
